export default __webpack_public_path__ + "media/images/logo-light-93994b46286e249ae2810d02b653d789.svg";